import { type RouteRecordRaw } from 'vue-router';

import { License } from '../../models';

export const soundscapeRoutes: RouteRecordRaw[] = [{
    path: 'soundscape/explore',
    name: 'explore',
    meta: {
        showInMenu: true,
        categoryIndex: 1,
        index: 0,
        licenses: {
            operator: 'and',
            licenses: [License.SPOT_AUDIO]
        },
        prependIcon: 'icon-discover',
        code: 'playdoo.routes.menu.explore'
    },
    component: () => import('./views/ExploreView.vue'),
    children: [{
        path: 'whats-new/playlists',
        name: 'explore.whats-new',
        meta: {
            code: 'playdoo.routes.explore.whats-new',
            breadcrumbs: true
        },
        component: () => import('./views/explore/WhatsNewView.vue')
    }, {
        path: 'whats-new/playlists/:playlistId',
        name: 'explore.whats-new.playlist',
        meta: {
            code: 'playdoo.routes.explore.playlist',
            breadcrumbs: true
        },
        component: () => import('./views/explore/WhatsNewPlaylistView.vue')
    }, {
        path: 'curations/:curationCategoryId',
        name: 'explore.curation-category',
        meta: {
            code: 'playdoo.routes.explore.curation-category',
            breadcrumbs: true
        },
        component: () => import('./views/explore/CurationCategoryView.vue')
    }, {
        path: 'curations/:curationCategoryId/:curationId/playlists/:playlistId',
        name: 'explore.curation-category.curation.playlist',
        meta: {
            code: 'playdoo.routes.explore.playlist',
            breadcrumbs: true
        },
        component: () => import('./views/explore/CurationPlaylistView.vue')
    }, {
        path: 'curations/:curationCategoryId/:curationId',
        name: 'explore.curation-category.curation',
        meta: {
            code: 'playdoo.routes.explore.curation',
            breadcrumbs: true
        },
        component: () => import('./views/explore/CurationView.vue')
    }]
}, {
    path: 'soundscape/music',
    name: 'music',
    redirect: { name: 'music.playlists' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 1,
        index: 1,
        licenses: {
            operator: 'and',
            licenses: [License.SPOT_AUDIO]
        },
        prependIcon: 'icon-music03',
        code: 'playdoo.routes.menu.music'
    },
    component: () => import('./views/MusicView.vue'),
    children: [{
        path: 'playlists/:playlistId',
        name: 'music.playlist',
        meta: {
            index: 0,
            code: 'playdoo.routes.music.playlist',
            breadcrumbs: true
        },
        component: () => import('./views/music/PlaylistView.vue')
    }, {
        path: 'children/:playlistId',
        name: 'music.children-playlist',
        meta: {
            index: 0,
            code: 'playdoo.routes.music.children-playlist',
            breadcrumbs: true
        },
        component: () => import('./views/music/ChildrenPlaylistView.vue')
    }, {
        path: 'playlists',
        name: 'music.playlists',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'playdoo.routes.music.playlists',
            query: ['scopeToggle']
        },
        component: () => import('./views/music/PlaylistsView.vue')
    }, {
        path: 'shared/:playlistId',
        name: 'music.shared-playlist',
        meta: {
            index: 1,
            code: 'playdoo.routes.music.shared-playlist',
            breadcrumbs: true
        },
        component: () => import('./views/music/SharedPlaylistView.vue')
    }, {
        path: 'shared',
        name: 'music.shared',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'playdoo.routes.music.shared',
            query: ['playlistToggle']
        },
        component: () => import('./views/music/SharedView.vue')
    }, {
        path: 'favorites',
        name: 'music.favorites',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'playdoo.routes.music.favorites',
            query: ['playlistToggle']
        },
        component: () => import('./views/music/FavoritesView.vue')
    }, {
        path: 'tracks',
        name: 'music.tracks',
        meta: {
            showInTabs: true,
            index: 3,
            code: 'playdoo.routes.music.tracks',
            query: ['scopeToggle']
        },
        component: () => import('./views/music/TracksView.vue')
    }, {
        path: 'catalog',
        name: 'music.catalog',
        meta: {
            showInTabs: true,
            index: 4,
            code: 'playdoo.routes.music.catalog'
        },
        component: () => import('./views/music/CatalogView.vue')
    }]
}, {
    path: 'soundscape/audio-messages',
    name: 'audio-messages',
    redirect: { name: 'audio-messages.campaigns' },
    meta: {
        showInMenu: true,
        hasTabs: true,
        categoryIndex: 1,
        index: 2,
        licenses: {
            operator: 'and',
            licenses: [License.SPOT_AUDIO]
        },
        prependIcon: 'icon-sound-message',
        code: 'playdoo.routes.menu.audio-messages'
    },
    component: () => import('./views/AudioMessagesView.vue'),
    children: [{
        path: 'campaigns/:campaignId',
        name: 'audio-messages.campaign',
        meta: {
            index: 0,
            code: 'playdoo.routes.audio-messages.campaign',
            breadcrumbs: true
        },
        component: () => import('./views/audioMessages/CampaignView.vue')
    }, {
        path: 'children/:campaignId',
        name: 'audio-messages.children-campaign',
        meta: {
            index: 0,
            code: 'playdoo.routes.audio-messages.children-campaign',
            breadcrumbs: true
        },
        component: () => import('./views/audioMessages/ChildrenCampaignView.vue')
    }, {
        path: 'campaigns',
        name: 'audio-messages.campaigns',
        meta: {
            showInTabs: true,
            index: 0,
            code: 'playdoo.routes.audio-messages.campaigns',
            query: ['scopeToggle']
        },
        component: () => import('./views/audioMessages/CampaignsView.vue')
    }, {
        path: 'shared/:campaignId',
        name: 'audio-messages.shared-campaign',
        meta: {
            index: 1,
            code: 'playdoo.routes.audio-messages.shared-campaign',
            breadcrumbs: true
        },
        component: () => import('./views/audioMessages/SharedCampaignView.vue')
    },  {
        path: 'shared',
        name: 'audio-messages.shared',
        meta: {
            showInTabs: true,
            index: 1,
            code: 'playdoo.routes.audio-messages.shared',
            query: ['campaignToggle']
        },
        component: () => import('./views/audioMessages/SharedView.vue')
    }, {
        path: 'favorites',
        name: 'audio-messages.favorites',
        meta: {
            showInTabs: true,
            index: 2,
            code: 'playdoo.routes.audio-messages.favorites',
            query: ['campaignToggle']
        },
        component: () => import('./views/audioMessages/FavoritesView.vue')
    }, {
        path: 'messages',
        name: 'audio-messages.messages',
        meta: {
            showInTabs: true,
            index: 3,
            code: 'playdoo.routes.audio-messages.messages',
            query: ['scopeToggle']
        },
        component: () => import('./views/audioMessages/MessagesView.vue')
    }]
}];